import React, { useState } from "react";
import SearchLocation from "../../NewCreateProposal/components/Summary/SearchLocation";
import TermsAndConditionsDialog from "./TermsAndConditionsDialog";
import {
  Checkbox,
  FormHelperText,
  FormControlLabel,
  Link,
} from "@mui/material";

function LocationInfo({
  selectedLocation,
  setSelectedLocation,
  setUserLocation,
  errObj,
  setErrObj,
  state,
  setState,
  isMobile
}) {
  const [isTermsAndConditionsDialogOpen, setIsTermsAndConditionsDialogOpen] =
    useState(false);

  const handleCloseTermsAndConditionsDialog = () => {
    setIsTermsAndConditionsDialogOpen(false);
  };

  const handleClickTermsAndConditionsLink = () => {
    setIsTermsAndConditionsDialogOpen(true);
  };

  const handleChangeTermsAcceptance = (e, checked) => {
    setState((prev) => ({ ...prev, areTermsAccepted: checked }));
    setErrObj({
      ...errObj,
      termsAndConditionErr: false,
      termsAndConditionMsg: "",
    });
  };

  const handleAcceptTerms = () => {
    setState((prev) => ({ ...prev, areTermsAccepted: true }));

    setErrObj({
      ...errObj,
      termsAndConditionErr: false,
      termsAndConditionMsg: "",
    });
  };

  return (
    <>
      <div style={{ marginBottom: "1.5vh" }}>
        <SearchLocation
          details={{ location: selectedLocation?.location || "" }}
          setDetails={(updater) => {
            const newDetails = typeof updater === 'function' ? updater({ location: selectedLocation?.location || "" }) : updater;
            setUserLocation(newDetails.location);
            setSelectedLocation({ location: newDetails.location });
            setErrObj({
              ...errObj,
              locationErr: false,
              locationMsg: "",
            });
          }}
          errObj={errObj}
          setErrObj={setErrObj}
        />
      </div>

      <FormControlLabel
        control={
          <Checkbox
            value={state.areTermsAccepted}
            checked={state.areTermsAccepted}
            onChange={handleChangeTermsAcceptance}
          />
        }
        label={
          <p style={{ color: "#0D0D0E", fontSize: "14px", fontWeight: "500" }}>
            I accept the
            <Link
              sx={{
                marginLeft: ".3vw",
                boxShadow: "none",
                textDecoration: "none",
                color: "#4D6BF6",
                fontSize: "14px",
                fontWeight: "500",
              }}
              onClick={handleClickTermsAndConditionsLink}
            >
              terms and conditions *
            </Link>
          </p>
        }
      />

      {errObj.termsAndConditionErr && (
        <FormHelperText
          error
          style={{ marginBottom: 20, fontFamily: "Inter Tight" }}
        >
          {errObj.termsAndConditionMsg}
        </FormHelperText>
      )}

      <TermsAndConditionsDialog
        open={isTermsAndConditionsDialogOpen}
        onClose={handleCloseTermsAndConditionsDialog}
        areTermsAccepted={state.areTermsAccepted}
        onAcceptTerms={handleAcceptTerms}
      />
    </>
  );
}

export default LocationInfo;
